//
// class for number data type
//
// @extends [DataFormatterType]
//
import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';
import { Localizer } from '../../localize/localizer';
import converter from 'convert-units';

import { DataFormatNumber } from './DataFormatNumber';

type uDistance = "mm" | "cm" | "m" | "km" | "in" | "ft-us" | "ft" | "mi";

interface DataFormatterWeightOptions extends DataFormatterOptions {
    convertfrom?: uDistance,
    convertto?: uDistance,
}

/**
 * Data formatter for length types.  Currently supports "mm" | "cm" | "m" | "km" | "in" | "ft-us" | "ft" | "mi"
 * @ignore
 */
export class DataFormatLength extends DataFormatNumber
{
    getName() : string
    {
        return "length";
    }

    /* Currency is stored internally as USD */
    getUnitText(options ?: DataFormatterOptions) : string
    {
        return "m";
    }

    /* Default options for the number formatter */
    initializeOptions() : DataFormatterOptions
    {
        return {
            format: "0,000.00"
        }
    }

    /*
    Format data as a number.
    Options can have format='<numeral js template>'
    */
    format(data: any, options?: DataFormatterWeightOptions, refObj?: any): string
    {
        const myOptions : DataFormatterOptions = this.getOptions(options);
        const targetValue = (myOptions.convertfrom && myOptions.convertto)
            ? converter(data).from(myOptions.convertfrom as uDistance).to(myOptions.convertto as uDistance)
            : data;

        const formatValue = super.format(targetValue, myOptions, refObj);

        // do we want to adjust the value in any way?
        return myOptions.displayunit ? `${formatValue} ${myOptions.displayunit}` : formatValue;
    }
}

export default DataFormatLength;
